<template>
  <div>
    <pre class="talk-text font-14 margin-b-5 padding-rl-5" v-html="item.content"></pre>
  </div>
</template>

<script>
export default {
  name: 'msgText',
}
</script>

<style scoped>
.talk-text {
  font-family: inherit;
  word-break: break-word;
  white-space: pre-wrap;
  overflow: hidden;
  line-height: 1.5;
}
.not-content {
  color: #FEC163;
}
</style>